var LightHelper = (function(){
    
    function LightHelper(light, sphereSize) {
        this.light = light;
        this.light.updateMatrixWorld();

        var geometry = new THREE.SphereGeometry(sphereSize, 4, 2);
        var material = new THREE.MeshBasicMaterial({wireframe: false, transparent: true});
        material.color.copy(this.light.color);

        THREE.Mesh.call(this, geometry, material);

        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
    }

    LightHelper.prototype = Object.create(THREE.Mesh.prototype);

    LightHelper.prototype.dispose = function () {
        this.geometry.dispose();
        this.material.dispose();
    };

    LightHelper.prototype.update = function () {
        this.material.color.copy( this.light.color );
    };

    return LightHelper;

})();